import cx from 'classnames';
import type { FunctionComponent } from 'react';
import styles from './Settings.module.less';

type Props = {
  isUnpadded?: boolean;
};

/**
 * SettingsPage is a very simple visual "page container" (panel) type
 * of component that is used to display any settings page.
 */
const SettingsPage: FunctionComponent<Props> = ({ children, isUnpadded }) => (
  <div className={cx(styles.page, {
    [styles.pageUnpadded]: isUnpadded,
  })}>
    {children}
  </div>
);

export default SettingsPage;
